import React, { useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";

let cache = null;
let pending = null;

const fetchOnce = () => {
  if (cache) return Promise.resolve(cache);
  if (pending) return pending;
  pending = api.get("/mascots").then((r) => { cache = r.data || {}; return cache; }).catch(() => ({}));
  return pending;
};

export default function CuratorBadge({ curator, size = "sm" }) {
  const [mascots, setMascots] = useState(cache);
  useEffect(() => { if (!cache) fetchOnce().then(setMascots); }, []);

  if (!curator) return null;
  const path = curator === "boggy" ? mascots?.boggy : mascots?.fox;
  const ring = curator === "boggy" ? "bg-green" : "bg-orange";
  const dim = size === "lg" ? "w-12 h-12" : "w-9 h-9";

  return (
    <div
      className={`${dim} ${ring} border-[3px] border-[#1A1A1A] overflow-hidden flex-shrink-0 relative`}
      style={{ boxShadow: "3px 3px 0 0 #1A1A1A" }}
      data-testid={`curator-badge-${curator}`}
      title={curator === "boggy" ? "Boggy's pick" : "Fox's pick"}
    >
      {path ? (
        <img
          src={fileUrl(path)}
          alt={curator}
          className="w-full h-full object-cover"
          style={{ objectPosition: "50% 18%" }}
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center font-display text-xs uppercase">
          {curator === "boggy" ? "Bg" : "Fx"}
        </div>
      )}
    </div>
  );
}
